import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { BaseComponent } from '../../../../../components/base.component';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { MonitorTab, MonitorTabList } from '../monitors.const';

declare var $: any;

@Component({
  selector: 'monitors-call-center',
  templateUrl: './call-center.component.html',
  styleUrls: ['./call-center.component.css'],
})
export class CallCenterComponent extends BaseComponent implements OnChanges, AfterViewInit {
  @Input() dataCallDashboard: any;
  @Input() dataAgentDashboard: any;
  @Output() onChangeTab: EventEmitter<{ tab: any }> = new EventEmitter();
  public agentStatus = {
    login: 0,
    ready: 0,
    readyNoAcd: 0,
    noReady: 0,
    inCampaign: 0,
    other: 0,
  };
  public callInbound = {
    total: 0,
    waiting: 0,
    answer: 0,
    hold: 0,
  };
  public callOutbound = {
    total: 0,
    waiting: 0,
    answer: 0,
    hold: 0,
  };

  public channelChartOptions: any = {};
  public readonly tabList = MonitorTabList;
  public readonly MonitorTab = MonitorTab;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService
  ) {
    super(changeDetector, toastr, modalService);
  }

  async ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    this.initData().then(data => {});
  }

  ngAfterViewInit(): void {}

  async initData() {
    if (this.dataCallDashboard) {
      this.agentStatus.login = this.dataAgentDashboard.loginAgentTotal || 0;
      this.agentStatus.ready = this.dataAgentDashboard.onlineAgentTotal || 0;
      this.agentStatus.readyNoAcd = this.dataAgentDashboard.noacdTotal || 0;
      this.agentStatus.noReady = this.dataAgentDashboard.notAvailableTotal || 0;
      this.agentStatus.inCampaign = this.dataAgentDashboard.oncampaignTotal || 0;
      this.agentStatus.other = this.dataAgentDashboard.breakTotal || 0;
    }
    if (this.dataCallDashboard) {
      this.callInbound.total = this.dataCallDashboard.inbound.callTotal || 0;
      this.callInbound.waiting = this.dataCallDashboard.inbound.callsInQueue || 0;
      this.callInbound.answer = this.dataCallDashboard.inbound.callsInAnswering || 0;
      this.callInbound.hold = this.dataCallDashboard.inbound.callsInHolding || 0;

      this.callOutbound.total = this.dataCallDashboard.outbound.callTotal || 0;
      this.callOutbound.waiting = this.dataCallDashboard.outbound.callsInQueue || 0;
      this.callOutbound.answer = this.dataCallDashboard.outbound.callsInAnswering || 0;
      this.callOutbound.hold = this.dataCallDashboard.outbound.callsInHolding || 0;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/monitors/call-center/call-center.component.ts